<div class="close" *ngIf="typebtn == 'close'"></div>
<div class="search" *ngIf="typebtn == 'search'"></div>
<div class="email" *ngIf="typebtn == 'email'"></div>
<div class="pdf" *ngIf="typebtn == 'pdf'"></div>